import type { Configuration, RedirectRequest } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_CLIENT_ID as string | undefined
const tenantId = import.meta.env.VITE_TENANT_ID as string | undefined
const apiClientId = import.meta.env.VITE_API_CLIENT_ID as string | undefined

export const isDevMode = !clientId

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || 'dev-placeholder',
    authority: `https://login.microsoftonline.us/${tenantId || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    knownAuthorities: ['login.microsoftonline.us'],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

export const loginRequest: RedirectRequest = {
  scopes: apiClientId ? [`api://${apiClientId}/access_as_user`] : [],
}

export const apiScopes = apiClientId
  ? [`api://${apiClientId}/access_as_user`]
  : []
